module.exports = __webpack_public_path__ + "img/priCloud.9a33ef53.png";